import { AsyncPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TextBlock } from '@generated/graphql';
import { CtaButtonComponent } from '@shared/cta-button/cta-button.component';
import { Observable } from 'rxjs';
import { HomeWhyFollowaliceReasonBlockComponent } from '../home-why-followalice-reason-block/home-why-followalice-reason-block.component';
import { CustomerReviewsContainerComponent } from './customer-reviews-container/customer-reviews-container.component';

@Component({
    selector: 'app-home-why-followalice',
    templateUrl: './home-why-followalice.component.html',
    styleUrls: ['./home-why-followalice.component.css'],
    imports: [
        HomeWhyFollowaliceReasonBlockComponent,
        AsyncPipe,
        CtaButtonComponent,
        CustomerReviewsContainerComponent,
    ],
})
export class HomeWhyFollowaliceComponent implements OnInit {
    @Input() reasons: Observable<TextBlock[]>;
    @Input() whyDesc: TextBlock;

    constructor() {}

    ngOnInit(): void {}
}
